export const metiersData = [
  
  {
    id: 1,
    name: "Infographiste",
    description: "Crée des images et des graphiques pour les sites web, applications, publicités et autres supports de communication.",
    video: "/videos/Infographiste.mp4",
    poster: "/images/Infographiste_Cover.png",
    skills: [
      "Créativité",
      "Maîtrise des logiciels graphiques",
      "Sens de l'esthétique",
      "Communication visuelle"
    ],
    nextRoute: "AdministrateurReseau"
  },
  {
    id: 2,
    name: "Administrateur réseau",
    description: "Installe et maintient les réseaux informatiques pour assurer leur bon fonctionnement et leur sécurité.",
    video: "/videos/Administrateur_reseau.mp4",
    poster: "/images/Administrateur_reseau_Cover.png",
    skills: [
      "Résolution de problèmes",
      "Connaissances techniques",
      "Organisation",
      "Veille technologique"
    ],
    nextRoute: "TechnicienTelecoms"
  },
  {
    id: 3,
    name: "Technicien télécoms",
    description: "Installe et répare les équipements de télécommunication comme les lignes téléphoniques, internet et la fibre optique.",
    video: "/videos/Technicien_telecoms.mp4",
    poster: "/images/Technicien_telecoms_Cover.png",
    skills: [
      "Habileté manuelle",
      "Connaissances techniques",
      "Autonomie",
      "Service client"
    ],
    nextRoute: "Webdesigner"
  },
  {
    id: 4,
    name: "Webdesigner",
    description: "Conçoit l'apparence visuelle et l'expérience utilisateur des sites web et applications mobiles.",
    video: "/videos/Webdesigner.mp4",
    poster: "/images/Webdesigner_Cover.png",
    skills: [
      "Créativité",
      "Codage HTML/CSS",
      "Sens esthétique",
      "Ergonomie"
    ],
    nextRoute: "TechnicienAutomatismes"
  },
  {
    id: 36,
    name: "Technicien en automatismes",
    description: "Installe, programme et maintient les systèmes automatisés utilisés dans l'industrie et les bâtiments intelligents.",
    video: "/videos/Technicien_automatismes.mp4",
    poster: "/images/Technicien_automatismes_Cover.png",
    skills: [
      "Programmation",
      "Dépannage",
      "Lecture de schémas",
      "Adaptabilité technique"
    ],
    nextRoute: "Cuisinier"
  },
  
  
  {
    id: 5,
    name: "Cuisinier/Cuisinière",
    description: "Prépare et cuisine des plats en suivant des recettes et en créant de nouvelles saveurs.",
    video: "/videos/Cuisinier_Cuisiniere.mp4",
    poster: "/images/Cuisinier_Cover.png",
    skills: [
      "Créativité culinaire",
      "Organisation",
      "Rapidité",
      "Hygiène alimentaire"
    ],
    nextRoute: "Boucher"
  },
  {
    id: 6,
    name: "Boucher/Bouchère",
    description: "Prépare et vend différents types de viandes en les découpant et les transformant en produits prêts à cuisiner.",
    video: "/videos/Boucher_Bouchere.mp4",
    poster: "/images/Boucher_Cover.png",
    skills: [
      "Précision",
      "Connaissance des viandes",
      "Service client",
      "Hygiène alimentaire"
    ],
    nextRoute: "Boulanger"
  },
  {
    id: 7,
    name: "Boulanger/Boulangère",
    description: "Fabrique du pain, des viennoiseries et des pâtisseries en suivant des recettes traditionnelles ou créatives.",
    video: "/videos/Boulanger_Boulangere.mp4",
    poster: "/images/Boulanger_Cover.png",
    skills: [
      "Précision",
      "Technique de pétrissage",
      "Créativité",
      "Travail matinal"
    ],
    nextRoute: "Patissier"
  },
  {
    id: 60,
    name: "Pâtissier/Pâtissière",
    description: "Crée et réalise des desserts, gâteaux et confiseries variés avec précision et sens artistique.",
    video: "/videos/Patissier_Patissiere.mp4",
    poster: "/images/Patissier_Cover.png",
    skills: [
      "Créativité",
      "Précision extrême",
      "Connaissance des techniques",
      "Décoration"
    ],
    nextRoute: "Sommelier"
  },
  {
    id: 61,
    name: "Sommelier/Sommelière",
    description: "Conseille les clients sur le choix des vins et gère la cave dans les restaurants gastronomiques.",
    video: "/videos/Sommelier_Sommeliere.mp4",
    poster: "/images/Sommelier_Cover.png",
    skills: [
      "Connaissance des vins",
      "Dégustation",
      "Service client",
      "Gestion de stock"
    ],
    nextRoute: "Poissonnier"
  },
  {
    id: 62,
    name: "Poissonnier/Poissonnière",
    description: "Prépare et vend des produits de la mer en garantissant leur fraîcheur et leur qualité.",
    video: "/videos/Poissonnier_Poissonniere.mp4",
    poster: "/images/Poissonnier_Cover.png",
    skills: [
      "Connaissance des produits marins",
      "Préparation et découpe",
      "Hygiène stricte",
      "Service client"
    ],
    nextRoute: "EmployeRestaurant"
  },
  {
    id: 63,
    name: "Employé de restaurant",
    description: "Accueille les clients, prend les commandes et assure le service en salle dans les établissements de restauration.",
    video: "/videos/Employe_restaurant.mp4",
    poster: "/images/Employe_restaurant_Cover.png",
    skills: [
      "Service client",
      "Rapidité",
      "Organisation",
      "Travail d'équipe"
    ],
    nextRoute: "IngenieurAgroequipement"
  },
  
  
  {
    id: 8,
    name: "Ingénieur R&D en agroéquipement",
    description: "Développe de nouvelles machines et outils pour améliorer l'efficacité et la durabilité de l'agriculture.",
    video: "/videos/Ingenieur_RD_agroequipement.mp4",
    poster: "/images/Ingenieur_agroequipement_Cover.png",
    skills: [
      "Innovation",
      "Connaissances techniques",
      "Analyse",
      "Travail en équipe"
    ],
    nextRoute: "TechnicienDemons"
  },
  {
    id: 23,
    name: "Technicien démonstrateur en matériel agricole",
    description: "Présente et explique le fonctionnement des équipements agricoles aux clients potentiels.",
    video: "/videos/Technicien_demonstrateur_agricole.mp4",
    poster: "/images/Technicien_demos_agricole_Cover.png",
    skills: [
      "Communication",
      "Connaissance des produits",
      "Technique de vente",
      "Manipulation d'équipements"
    ],
    nextRoute: "TechnicienPrototypiste"
  },
  {
    id: 45,
    name: "Technicien prototypiste en agroéquipement",
    description: "Fabrique et teste les premiers modèles des nouveaux équipements agricoles avant leur production en série.",
    video: "/videos/Technicien_prototypiste.mp4",
    poster: "/images/Technicien_prototypiste_Cover.png",
    skills: [
      "Précision technique",
      "Résolution de problèmes",
      "Adaptabilité",
      "Travail d'équipe"
    ],
    nextRoute: "FormateurAgroequipement"
  },
  {
    id: 55,
    name: "Formateur technique en agroéquipement",
    description: "Enseigne l'utilisation et la maintenance des machines agricoles aux professionnels du secteur.",
    video: "/videos/Formateur_agroequipement.mp4",
    poster: "/images/Formateur_agroequipement_Cover.png",
    skills: [
      "Pédagogie",
      "Expertise technique",
      "Communication",
      "Patience"
    ],
    nextRoute: "ConducteurMachinesAgricoles"
  },
  {
    id: 9,
    name: "Conducteur de machines agricoles",
    description: "Utilise et entretient des tracteurs et autres machines pour cultiver les champs et récolter les produits agricoles.",
    video: "/videos/Conducteur_machines_agricoles.mp4",
    poster: "/images/Conducteur_agricole_Cover.png",
    skills: [
      "Conduite d'engins",
      "Mécanique de base",
      "Travail en extérieur",
      "Adaptabilité"
    ],
    nextRoute: "ConducteurTravauxAgricoles"
  },
  {
    id: 42,
    name: "Conducteur de travaux en entreprises agricoles",
    description: "Coordonne et supervise les chantiers agricoles en organisant les équipes et le matériel.",
    video: "/videos/Conducteur_travaux_agricoles.mp4",
    poster: "/images/Conducteur_travaux_agricoles_Cover.png",
    skills: [
      "Organisation",
      "Leadership",
      "Gestion de projet",
      "Connaissance technique"
    ],
    nextRoute: "MecanicienAgricole"
  },
  {
    id: 17,
    name: "Mécanicien-réparateur en matériel agricole",
    description: "Entretient et répare les tracteurs et autres machines agricoles pour garantir leur bon fonctionnement.",
    video: "/videos/Mecanicien_materiel_agricole.mp4",
    poster: "/images/Mecanicien_agricole_Cover.png",
    skills: [
      "Diagnostic technique",
      "Réparation mécanique",
      "Lecture de schémas",
      "Adaptabilité"
    ],
    nextRoute: "Horticulteur"
  },
  {
    id: 10,
    name: "Horticulteur/Horticultrice",
    description: "Cultive des fleurs, plantes, arbustes et légumes en veillant à leur croissance et leur santé.",
    video: "/videos/Horticulteur_Horticultrice.mp4",
    poster: "/images/Horticulteur_Cover.png",
    skills: [
      "Connaissance des plantes",
      "Patience",
      "Travail en extérieur",
      "Observation"
    ],
    nextRoute: "JardinierPaysagiste"
  },
  {
    id: 11,
    name: "Jardinier/Jardinière-paysagiste",
    description: "Crée et entretient des jardins, parcs et espaces verts en plantant et taillant arbres, arbustes et fleurs.",
    video: "/videos/Jardinier_Jardiniere.mp4",
    poster: "/images/Jardinier_Cover.png",
    skills: [
      "Créativité paysagère",
      "Connaissance des plantes",
      "Travail en extérieur",
      "Habileté manuelle"
    ],
    nextRoute: "Viticulteur"
  },
  {
    id: 18,
    name: "Viticulteur/Viticultrice",
    description: "Cultive la vigne pour produire des raisins destinés à la fabrication du vin.",
    video: "/videos/Viticulteur_Viticultrice.mp4",
    poster: "/images/Viticulteur_Cover.png",
    skills: [
      "Connaissance de la vigne",
      "Travail en extérieur",
      "Patience",
      "Analyse des sols"
    ],
    nextRoute: "EleveurOvins"
  },
  {
    id: 19,
    name: "Éleveur/Éleveuse d'ovins",
    description: "Élève des moutons pour leur laine, leur viande ou leur lait en veillant à leur bien-être et leur santé.",
    video: "/videos/Eleveur_ovins.mp4",
    poster: "/images/Eleveur_ovins_Cover.png",
    skills: [
      "Soin des animaux",
      "Gestion d'exploitation",
      "Travail en extérieur",
      "Observation"
    ],
    nextRoute: "Fleuriste"
  },
  {
    id: 20,
    name: "Fleuriste",
    description: "Compose et vend des bouquets et arrangements floraux pour différentes occasions en travaillant avec des fleurs fraîches.",
    video: "/videos/Fleuriste.mp4",
    poster: "/images/Fleuriste_Cover.png",
    skills: [
      "Créativité artistique",
      "Connaissance des fleurs",
      "Service client",
      "Rapidité d'exécution"
    ],
    nextRoute: "TapissierAmeublement"
  },
  
  
  {
    id: 12,
    name: "Tapissier/Tapissière d'ameublement",
    description: "Restaure ou crée des fauteuils, canapés et sièges en travaillant les tissus, mousses et structures.",
    video: "/videos/Tapissier_Tapissiere.mp4",
    poster: "/images/Tapissier_Cover.png",
    skills: [
      "Habileté manuelle",
      "Créativité",
      "Précision",
      "Connaissance des tissus"
    ],
    nextRoute: "TailleurCouturier"
  },
  {
    id: 15,
    name: "Tailleur-couturier/Tailleuse-couturière",
    description: "Crée ou modifie des vêtements sur mesure en travaillant différents tissus selon les besoins des clients.",
    video: "/videos/Tailleur_Couturier.mp4",
    poster: "/images/Tailleur_Cover.png",
    skills: [
      "Habileté manuelle",
      "Sens de l'esthétique",
      "Précision",
      "Service client"
    ],
    nextRoute: "BijoitierJoaillier"
  },
  {
    id: 24,
    name: "Bijoutier-joaillier/Bijoutière-joaillière",
    description: "Conçoit et fabrique des bijoux en utilisant des métaux précieux et des pierres.",
    video: "/videos/Bijoutier_Joaillier.mp4",
    poster: "/images/Bijoutier_Cover.png",
    skills: [
      "Précision extrême",
      "Créativité",
      "Connaissance des matériaux",
      "Patience"
    ],
    nextRoute: "Tonnelier"
  },
  {
    id: 16,
    name: "Tonnelier/Tonnelière",
    description: "Fabrique et répare des tonneaux en bois utilisés pour le vieillissement du vin et des spiritueux.",
    video: "/videos/Tonnelier_Tonneliere.mp4",
    poster: "/images/Tonnelier_Cover.png",
    skills: [
      "Travail du bois",
      "Précision",
      "Connaissance des traditions",
      "Force physique"
    ],
    nextRoute: "TailleurPierre"
  },
  {
    id: 35,
    name: "Tailleur/Tailleuse de pierre",
    description: "Sculpte et façonne la pierre pour la construction, la décoration ou la restauration de monuments.",
    video: "/videos/Tailleur_pierre.mp4",
    poster: "/images/Tailleur_pierre_Cover.png",
    skills: [
      "Habileté manuelle",
      "Précision",
      "Connaissance des matériaux",
      "Force physique"
    ],
    nextRoute: "Techniverrier"
  },
  {
    id: 34,
    name: "Techniverrier/Techniverrière",
    description: "Travaille le verre pour créer des objets décoratifs, techniques ou artistiques.",
    video: "/videos/Techniverrier.mp4",
    poster: "/images/Techniverrier_Cover.png",
    skills: [
      "Précision",
      "Créativité",
      "Résistance à la chaleur",
      "Technicité"
    ],
    nextRoute: "Chaudronnier"
  },
  {
    id: 56,
    name: "Chaudronnier/Chaudronnière",
    description: "Façonne et assemble des pièces métalliques pour créer des structures et équipements industriels.",
    video: "/videos/Chaudronnier_Chaudronniere.mp4",
    poster: "/images/Chaudronnier_Cover.png",
    skills: [
      "Travail des métaux",
      "Lecture de plans",
      "Précision",
      "Force physique"
    ],
    nextRoute: "Ebeniste"
  },
  {
    id: 47,
    name: "Ébéniste",
    description: "Crée et restaure des meubles de qualité en bois massif avec un haut niveau de finition.",
    video: "/videos/Ebeniste.mp4",
    poster: "/images/Ebeniste_Cover.png",
    skills: [
      "Travail du bois",
      "Précision",
      "Créativité",
      "Patience"
    ],
    nextRoute: "ProthesisteDentaire"
  },
  
  
  {
    id: 13,
    name: "Prothésiste dentaire",
    description: "Fabrique des prothèses dentaires comme les couronnes, bridges et dentiers sur prescription des dentistes.",
    video: "/videos/Prothesiste_dentaire.mp4",
    poster: "/images/Prothesiste_dentaire_Cover.png",
    skills: [
      "Précision extrême",
      "Habileté manuelle",
      "Connaissance anatomique",
      "Utilisation d'outils spécialisés"
    ],
    nextRoute: "EstheticienCosmeticien"
  },
  {
    id: 21,
    name: "Esthéticien-cosméticien/Esthéticienne-cosméticienne",
    description: "Réalise des soins du visage et du corps pour embellir et entretenir la peau et l'apparence.",
    video: "/videos/Estheticien_Cosmeticien.mp4",
    poster: "/images/Estheticien_Cover.png",
    skills: [
      "Délicatesse",
      "Connaissance des soins",
      "Relation client",
      "Hygiène parfaite"
    ],
    nextRoute: "Coiffeur"
  },
  {
    id: 25,
    name: "Coiffeur/Coiffeuse",
    description: "Réalise des coupes, colorations, et coiffures adaptées aux souhaits et à la personnalité de chaque client.",
    video: "/videos/Coiffeur_Coiffeuse.mp4",
    poster: "/images/Coiffeur_Cover.png",
    skills: [
      "Créativité",
      "Précision manuelle",
      "Écoute du client",
      "Connaissance des produits capillaires"
    ],
    nextRoute: "AuxiliaireVieSociale"
  },
  {
    id: 26,
    name: "Auxiliaire de vie sociale",
    description: "Aide les personnes dépendantes dans leur vie quotidienne à domicile pour maintenir leur autonomie.",
    video: "/videos/Auxiliaire_vie_sociale.mp4",
    poster: "/images/Auxiliaire_vie_Cover.png",
    skills: [
      "Empathie",
      "Patience",
      "Organisation",
      "Adaptabilité"
    ],
    nextRoute: "Mecatronicien"
  },
  {
    id: 14,
    name: "Mécatronicien/Mécatronicienne",
    description: "Conçoit et maintient des systèmes combinant mécanique, électronique et informatique comme les robots industriels.",
    video: "/videos/Mecatronicien_Mecatronicienne.mp4",
    poster: "/images/Mecatronicien_Cover.png",
    skills: [
      "Expertise technique",
      "Résolution de problèmes",
      "Précision",
      "Adaptabilité"
    ],
    nextRoute: "TechnicienMaintenanceIndustrielle"
  },
  {
    id: 27,
    name: "Technicien en maintenance industrielle",
    description: "Assure le bon fonctionnement des machines et équipements dans les usines et sites de production.",
    video: "/videos/Technicien_maintenance_industrielle.mp4",
    poster: "/images/Technicien_maintenance_industrielle_Cover.png",
    skills: [
      "Diagnostic technique",
      "Réparation",
      "Travail d'équipe",
      "Réactivité"
    ],
    nextRoute: "TechnicienFrigoriste"
  },
  {
    id: 28,
    name: "Technicien frigoriste",
    description: "Installe et entretient les systèmes de réfrigération et de climatisation dans les commerces et industries.",
    video: "/videos/Technicien_frigoriste.mp4",
    poster: "/images/Technicien_frigoriste_Cover.png",
    skills: [
      "Connaissance des fluides",
      "Dépannage",
      "Lecture de schémas",
      "Rigueur"
    ],
    nextRoute: "MecanicienEntretienAvion"
  },
  {
    id: 32,
    name: "Mécanicien d'entretien d'avion",
    description: "Assure la maintenance et la réparation des aéronefs pour garantir leur sécurité et leur fiabilité.",
    video: "/videos/Mecanicien_entretien_avion.mp4",
    poster: "/images/Mecanicien_avion_Cover.png",
    skills: [
      "Précision extrême",
      "Respect des procédures",
      "Connaissance technique",
      "Responsabilité"
    ],
    nextRoute: "DessinateurConstructionMecanique"
  },
  {
    id: 33,
    name: "Dessinateur en construction mécanique",
    description: "Conçoit les plans détaillés des pièces et assemblages mécaniques utilisés dans l'industrie.",
    video: "/videos/Dessinateur_construction_mecanique.mp4",
    poster: "/images/Dessinateur_mecanique_Cover.png",
    skills: [
      "Maîtrise des logiciels CAO",
      "Précision",
      "Vision spatiale",
      "Connaissances techniques"
    ],
    nextRoute: "Soudeur"
  },
  {
    id: 29,
    name: "Soudeur/Soudeuse",
    description: "Assemble par fusion ou par apport de métal les différents éléments métalliques pour créer des structures solides.",
    video: "/videos/Soudeur_Soudeuse.mp4",
    poster: "/images/Soudeur_Cover.png",
    skills: [
      "Précision et minutie",
      "Maîtrise des techniques de soudure",
      "Respect des règles de sécurité",
      "Lecture de plans techniques"
    ],
    nextRoute: "OperateurMachineCN"
  },
  {
    id: 30,
    name: "Opérateur sur machine à commande numérique",
    description: "Pilote et surveille les machines automatisées qui fabriquent des pièces mécaniques de précision.",
    video: "/videos/Operateur_machine_CN.mp4",
    poster: "/images/Operateur_CN_Cover.png",
    skills: [
      "Programmation",
      "Vigilance",
      "Contrôle qualité",
      "Lecture de plans"
    ],
    nextRoute: "TechnicienAutomobile"
  },
  
  
  {
    id: 52,
    name: "Technicien automobile",
    description: "Diagnostique et répare les problèmes mécaniques et électroniques des véhicules pour assurer leur bon fonctionnement.",
    video: "/videos/Technicien_automobile.mp4",
    poster: "/images/Technicien_auto_Cover.png",
    skills: [
      "Diagnostic technique",
      "Connaissance mécanique",
      "Utilisation d'outils spécialisés",
      "Adaptabilité"
    ],
    nextRoute: "PeintreCarrosserie"
  },
  {
    id: 53,
    name: "Peintre en carrosserie",
    description: "Prépare et applique les peintures sur les véhicules pour leur donner un aspect neuf ou personnalisé.",
    video: "/videos/Peintre_carrosserie.mp4",
    poster: "/images/Peintre_carrosserie_Cover.png",
    skills: [
      "Précision",
      "Connaissance des produits",
      "Perception des couleurs",
      "Patience"
    ],
    nextRoute: "MecanicienVehiculeIndustriel"
  },
  {
    id: 54,
    name: "Mécanicien de véhicule industriel",
    description: "Entretient et répare les poids lourds, bus et engins de chantier pour garantir leur performance.",
    video: "/videos/Mecanicien_vehicule_industriel.mp4",
    poster: "/images/Mecanicien_industriel_Cover.png",
    skills: [
      "Force physique",
      "Connaissance technique",
      "Diagnostic",
      "Adaptabilité"
    ],
    nextRoute: "MecanicienCycleMotocycle"
  },
  {
    id: 58,
    name: "Mécanicien en cycle et motocycle",
    description: "Répare et entretient les vélos, scooters et motos pour assurer leur bon fonctionnement et leur sécurité.",
    video: "/videos/Mecanicien_cycle_motocycle.mp4",
    poster: "/images/Mecanicien_cycle_Cover.png",
    skills: [
      "Précision",
      "Diagnostic",
      "Mécanique fine",
      "Service client"
    ],
    nextRoute: "CarrossierReparateur"
  },
  {
    id: 59,
    name: "Carrossier-réparateur/Carrossière-réparatrice",
    description: "Remet en état les carrosseries de véhicules endommagées lors d'accidents ou par la corrosion.",
    video: "/videos/Carrossier_reparateur.mp4",
    poster: "/images/Carrossier_Cover.png",
    skills: [
      "Habileté manuelle",
      "Sens de l'esthétique",
      "Précision",
      "Connaissance des matériaux"
    ],
    nextRoute: "Electricien"
  },
  
  
  {
    id: 43,
    name: "Électricien/Électricienne",
    description: "Installe, répare et entretient les systèmes électriques dans les bâtiments résidentiels et commerciaux.",
    video: "/videos/Electricien_Electricienne.mp4",
    poster: "/images/Electricien_Cover.png",
    skills: [
      "Expertise technique",
      "Lecture de plans",
      "Respect des normes de sécurité",
      "Résolution de problèmes"
    ],
    nextRoute: "PlombierChauffagiste"
  },
  {
    id: 38,
    name: "Plombier-chauffagiste",
    description: "Installe et répare les systèmes d'eau, de gaz et de chauffage dans les bâtiments.",
    video: "/videos/Plombier_chauffagiste.mp4",
    poster: "/images/Plombier_Cover.png",
    skills: [
      "Habileté manuelle",
      "Résolution de problèmes",
      "Lecture de plans",
      "Adaptabilité"
    ],
    nextRoute: "Platrier"
  },
  {
    id: 39,
    name: "Plâtrier/Plâtrière",
    description: "Installe les cloisons, plafonds et autres éléments en plâtre dans les bâtiments.",
    video: "/videos/Platrier_Platriere.mp4",
    poster: "/images/Platrier_Cover.png",
    skills: [
      "Habileté manuelle",
      "Précision",
      "Endurance physique",
      "Lecture de plans"
    ],
    nextRoute: "PeintreBatiment"
  },
  {
    id: 44,
    name: "Peintre en bâtiment",
    description: "Prépare et applique les peintures sur les murs, plafonds et autres surfaces dans les bâtiments.",
    video: "/videos/Peintre_batiment.mp4",
    poster: "/images/Peintre_batiment_Cover.png",
    skills: [
      "Précision",
      "Sens de l'esthétique",
      "Organisation",
      "Habileté manuelle"
    ],
    nextRoute: "Menuisier"
  },
  {
    id: 46,
    name: "Menuisier/Menuisière",
    description: "Fabrique et installe des éléments en bois comme les portes, fenêtres et escaliers dans les bâtiments.",
    video: "/videos/Menuisier_Menuisiere.mp4",
    poster: "/images/Menuisier_Cover.png",
    skills: [
      "Travail du bois",
      "Précision",
      "Lecture de plans",
      "Habileté manuelle"
    ],
    nextRoute: "Macon"
  },
  {
    id: 48,
    name: "Maçon/Maçonne",
    description: "Construit les murs, fondations et structures en pierre, brique ou béton des bâtiments.",
    video: "/videos/Macon_Maconne.mp4",
    poster: "/images/Macon_Cover.png",
    skills: [
      "Force physique",
      "Précision",
      "Lecture de plans",
      "Travail d'équipe"
    ],
    nextRoute: "Couvreur"
  },
  {
    id: 49,
    name: "Couvreur/Couvreuse",
    description: "Installe et répare les toitures des bâtiments pour les protéger des intempéries.",
    video: "/videos/Couvreur_Couvreuse.mp4",
    poster: "/images/Couvreur_Cover.png",
    skills: [
      "Travail en hauteur",
      "Précision",
      "Résistance physique",
      "Respect des normes de sécurité"
    ],
    nextRoute: "ConstructeurRoute"
  },
  {
    id: 50,
    name: "Constructeur de route et canalisateur",
    description: "Construit et entretient les routes, trottoirs et systèmes d'évacuation d'eau.",
    video: "/videos/Constructeur_route.mp4",
    poster: "/images/Constructeur_route_Cover.png",
    skills: [
      "Travail en extérieur",
      "Force physique",
      "Précision",
      "Travail d'équipe"
    ],
    nextRoute: "ConstructeurBetonArme"
  },
  {
    id: 51,
    name: "Constructeur en béton armé",
    description: "Réalise les structures en béton armé des bâtiments et ouvrages d'art.",
    video: "/videos/Constructeur_beton.mp4",
    poster: "/images/Constructeur_beton_Cover.png",
    skills: [
      "Force physique",
      "Précision",
      "Lecture de plans",
      "Travail en hauteur"
    ],
    nextRoute: "CharpentierBois"
  },
  {
    id: 64,
    name: "Charpentier bois/Charpentière bois",
    description: "Conçoit et installe les structures en bois qui supportent les toitures des bâtiments.",
    video: "/videos/Charpentier_bois.mp4",
    poster: "/images/Charpentier_Cover.png",
    skills: [
      "Travail du bois",
      "Travail en hauteur",
      "Lecture de plans",
      "Force physique"
    ],
    nextRoute: "CarreleurMosaiste"
  },
  {
    
    id: 65,
    name: "Carreleur-mosaïste/Carreleuse-mosaïste",
    description: "Pose les carrelages et mosaïques sur les sols et murs des bâtiments.",
    video: "/videos/Carreleur_mosaiste.mp4",
    poster: "/images/Carreleur_Cover.png",
    skills: [
      "Précision",
      "Sens de l'esthétique",
      "Habileté manuelle",
      "Endurance physique"
    ],
    nextRoute: "SerrurierMetallier"
  },
  {
    id: 37,
    name: "Serrurier-Métallier/Serrurière-Métallière",
    description: "Fabrique et installe les éléments métalliques comme les portes, portails et garde-corps.",
    video: "/videos/Serrurier_metallier.mp4",
    poster: "/images/Serrurier_Cover.png",
    skills: [
      "Travail des métaux",
      "Précision",
      "Lecture de plans",
      "Force physique"
    ],
    nextRoute: "SolierMoquettiste"
  },
  {
    id: 40,
    name: "Solier-moquettiste/Solière-moquettiste",
    description: "Pose les revêtements de sol souples comme le lino, la moquette et le PVC.",
    video: "/videos/Solier_moquettiste.mp4",
    poster: "/images/Solier_Cover.png",
    skills: [
      "Habileté manuelle",
      "Précision",
      "Sens de l'esthétique",
      "Endurance physique"
    ],
    nextRoute: "ConducteurMachineImprimer"
  },
  
  {
    id: 41,
    name: "Conducteur/Conductrice de machine à imprimer",
    description: "Pilote et surveille les presses et autres machines d'imprimerie pour produire livres, magazines et emballages.",
    video: "/videos/Conducteur_machine_imprimer.mp4",
    poster: "/images/Conducteur_imprimerie_Cover.png",
    skills: [
      "Vigilance",
      "Réactivité",
      "Connaissance technique",
      "Sens des couleurs"
    ],
    nextRoute: "Infographiste"
  }
];